module.exports = __webpack_public_path__ + "img/bowl-pile.819e0b73.svg";